/* @flow */
import React from 'react';
import Button from 'components/Button.jsx';

import cx from 'classnames';

import './styles/DialogButton.scss';

class DialogButton extends React.Component {
  static propTypes = {
    text: React.PropTypes.string,
  };

  renderText = () => {
    return this.props.text || null;
  };

  render() {
    return (
      <footer className="DialogButton-wrap">
        <Button {...this.props} className={cx('DialogButton', this.props.className)}>
          {this.renderText()}
          {this.props.children}
        </Button>
      </footer>
    );
  }
}

export default DialogButton;



// WEBPACK FOOTER //
// ./src/components/DialogButton.jsx